import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/selects/DropdownHeader.tsx
var n = (n) => {
	let { icon: r, label: i, center: a = !0, className: o = "" } = n;
	return /* @__PURE__ */ e("li", {
		className: `dropdown-header ${a ? "center" : ""} ${o}`,
		children: /* @__PURE__ */ t("span", {
			className: "dropdown-header-text",
			children: [r && /* @__PURE__ */ e("span", {
				className: "margin-right-5",
				children: r
			}), i]
		})
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=DropdownHeader.js.map